import type { LiveStatus } from "@/mocks/lives";

interface StatusBadgeProps {
  status: LiveStatus;
  className?: string;
}

export default function StatusBadge({ status, className = "" }: StatusBadgeProps) {
  if (status === "live") {
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-2 py-1 text-[11px] font-label font-bold uppercase tracking-wide text-background-50 ${className}`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-background-50 animate-live-pulse" />
        直播中
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md bg-secondary-500/90 px-2 py-1 text-[11px] font-label font-bold tracking-wide text-background-50 ${className}`}
    >
      <i className="ri-time-line text-xs" />
      预告
    </span>
  );
}